import { arrayOf, object } from 'vue-types';
import { VmsPluginCameraStream } from '@/api/models/VmsPluginCamerasRequest';

export function defineStreamsProp() {
  return arrayOf(object<VmsPluginCameraStream>()).isRequired;
}
